<template>
	<div class="basic_wrap">
		<!-- 顶部标题 -->
		<div class="project_header">
			<div class="back_left" @click="$router.back()">
				<img src="../../../src/assets/images/return-w.png" alt="">
			</div>
			<div class="big_tit">{{ $t('item.ProjectDetails') }}</div>
		</div>

		<!-- 蓝色主要内容区域 -->
		<div class="blue_section">
			<!-- 产品名称 -->
			<div class="product_name">{{ projectData ? projectData.title + ' (' + projectData.day + getUnitText(projectData.unit) + ')' : $t('item.Loading') }}</div>
			
			<!-- 当前利率显示 -->
			<div class="rate_bubble">
				<div class="rate_arrow"></div>
				<div class="rate_text">{{ $t('item.CurrentRate') }}: {{ projectData ? projectData.rate + '%' : '0%' }}</div>
			</div>
			
			<!-- 财务概览网格 -->
			<div class="financial_grid">
				<div class="grid_item">
					<div class="grid_label">{{ $t('item.TotalPrincipal') }}</div>
					<div class="grid_value">{{ projectData ? '$' + projectData.total_principal : '$0.00' }}</div>
				</div>
				<div class="grid_item">
					<div class="grid_label">{{ $t('item.ExpectedEarnings') }}</div>
					<!-- <div class="grid_value">{{ projectData ? projectData.expected_income + '%' : '0%' }}</div> -->
					<div class="grid_value">{{ projectData ? projectData.expected_income  : '0' }}</div>
				</div>
				<div class="grid_item">
					<div class="grid_label">{{ $t('item.AccumulatedEarnings') }}</div>
					<!-- <div class="grid_value">{{ projectData ? projectData.total_income + '%' : '0%' }}</div> -->
					<div class="grid_value">{{ projectData ? projectData.total_income  : '0' }}</div>
				</div>
				<div class="grid_item">
					<div class="grid_label">{{ $t('item.EarningsCountdown') }}</div>
					<div class="grid_value" :class="countdownClass">{{ getCurrentCountdownText() }}</div>
				</div>
			</div>
			
			<!-- 转入限制说明 -->
			<div class="transfer_limits">
				<div class="limit_item">
					<div class="limit_symbol">
						<svg t="1761441961128" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6907" width="30" height="30"><path d="M542.4 750.4v-32c22.4-3.2 38.4-11.2 51.2-25.6 12.8-14.4 17.6-30.4 17.6-51.2 0-17.6-4.8-33.6-14.4-44.8-9.6-11.2-28.8-20.8-54.4-28.8v-65.6c11.2 4.8 17.6 14.4 20.8 27.2l41.6-6.4c-3.2-17.6-9.6-30.4-20.8-40-9.6-9.6-24-16-43.2-17.6v-16h-24v16c-19.2 1.6-35.2 9.6-46.4 22.4-11.2 12.8-17.6 27.2-17.6 46.4 0 17.6 4.8 33.6 16 46.4 11.2 12.8 27.2 22.4 48 28.8v70.4c-6.4-3.2-11.2-8-16-14.4-4.8-6.4-8-14.4-9.6-22.4l-44.8 4.8c3.2 22.4 11.2 40 22.4 51.2 12.8 12.8 28.8 19.2 48 22.4V752h25.6z m0-134.4c9.6 3.2 17.6 6.4 22.4 12.8 4.8 4.8 6.4 12.8 6.4 19.2 0 8-3.2 16-8 22.4-4.8 6.4-12.8 9.6-20.8 11.2v-65.6z m-41.6-67.2c-3.2-4.8-4.8-11.2-4.8-16 0-6.4 1.6-12.8 6.4-17.6 4.8-4.8 9.6-9.6 16-11.2V560c-8-3.2-14.4-6.4-17.6-11.2z" fill="#1296db" p-id="6908"></path><path d="M172.8 708.8V489.6c44.8 0 80-35.2 80-80h206.4l-40-48H174.4c-27.2 0-49.6 22.4-49.6 49.6v374.4c0 27.2 22.4 49.6 49.6 49.6h508.8c0-16 3.2-33.6 8-48H252.8c0-43.2-35.2-78.4-80-78.4zM804.8 409.6c0 44.8 35.2 80 80 80V656c16 1.6 33.6 4.8 48 9.6v-256c0-27.2-22.4-49.6-49.6-49.6H638.4l-40 48h206.4z" fill="#1296db" p-id="6909"></path><path d="M340.8 558.4H288c-4.8 0-8 3.2-8 8s3.2 8 8 8h54.4c4.8 0 8-3.2 8-8s-4.8-8-9.6-8zM340.8 592H288c-4.8 0-8 3.2-8 8s3.2 8 8 8h54.4c4.8 0 8-3.2 8-8s-4.8-8-9.6-8zM340.8 624H288c-4.8 0-8 3.2-8 8s3.2 8 8 8h54.4c4.8 0 8-3.2 8-8-1.6-4.8-4.8-8-9.6-8zM771.2 558.4h-54.4c-4.8 0-8 3.2-8 8s3.2 8 8 8h54.4c4.8 0 8-3.2 8-8s-4.8-8-8-8zM771.2 592h-54.4c-4.8 0-8 3.2-8 8s3.2 8 8 8h54.4c4.8 0 8-3.2 8-8s-4.8-8-8-8zM771.2 640c4.8 0 8-3.2 8-8s-3.2-8-8-8h-54.4c-4.8 0-8 3.2-8 8s3.2 8 8 8h54.4zM515.2 427.2c6.4 8 19.2 8 27.2 0l70.4-86.4c9.6-11.2 1.6-28.8-12.8-28.8h-11.2V44.8c0-9.6-8-17.6-17.6-17.6h-84.8c-9.6 0-17.6 8-17.6 17.6v267.2h-11.2c-14.4 0-22.4 17.6-12.8 28.8l70.4 86.4zM25.6 307.2c0-70.4 57.6-128 128-128s128 57.6 128 128c0 8 0 16-1.6 22.4h27.2c1.6-8 1.6-14.4 1.6-22.4 0-84.8-68.8-153.6-153.6-153.6-86.4 0-155.2 68.8-155.2 153.6 0 62.4 38.4 116.8 92.8 140.8v-28.8c-40-22.4-67.2-64-67.2-112z" fill="#1296db" p-id="6910"></path><path d="M136 270.4c0 3.2 1.6 6.4 3.2 9.6 1.6 3.2 4.8 4.8 8 6.4V256c-3.2 0-6.4 3.2-8 4.8-1.6 3.2-3.2 6.4-3.2 9.6zM160 315.2v35.2c4.8-1.6 8-3.2 11.2-6.4 3.2-3.2 4.8-8 4.8-11.2v-3.2c0-3.2-1.6-4.8-3.2-8-3.2-3.2-6.4-4.8-12.8-6.4z" fill="#1296db" p-id="6911"></path><path d="M132.8 329.6c0 3.2 1.6 6.4 3.2 9.6 0 1.6 1.6 1.6 1.6 3.2l8 8v-36.8c-9.6-4.8-17.6-9.6-24-17.6-4.8-6.4-8-14.4-8-24s3.2-17.6 9.6-24c6.4-6.4 14.4-11.2 24-11.2v-9.6h12.8v9.6c9.6 1.6 17.6 4.8 22.4 9.6 6.4 4.8 9.6 12.8 11.2 20.8l-22.4 3.2c-1.6-6.4-4.8-11.2-11.2-14.4v35.2c14.4 3.2 24 9.6 28.8 14.4 4.8 6.4 8 14.4 8 24h57.6c1.6-8 3.2-14.4 3.2-22.4 0-57.6-46.4-104-104-104s-104 46.4-104 104c0 35.2 17.6 67.2 44.8 84.8 3.2-16 11.2-28.8 22.4-40-3.2-6.4-6.4-12.8-8-20.8l24-1.6zM870.4 689.6c-84.8 0-153.6 68.8-153.6 153.6s68.8 153.6 153.6 153.6S1024 928 1024 843.2s-68.8-153.6-153.6-153.6z m0 280c-70.4 0-128-57.6-128-128s57.6-128 128-128 128 57.6 128 128c0 72-57.6 128-128 128z" fill="#1296db" p-id="6912"></path><path d="M856 796.8c-1.6 3.2-3.2 6.4-3.2 9.6 0 3.2 1.6 6.4 3.2 9.6 1.6 3.2 4.8 4.8 8 6.4v-30.4c-3.2 0-6.4 3.2-8 4.8zM876.8 851.2v35.2c4.8-1.6 8-3.2 11.2-6.4 3.2-3.2 4.8-8 4.8-11.2 0-4.8-1.6-8-3.2-11.2-3.2-3.2-6.4-4.8-12.8-6.4z" fill="#1296db" p-id="6913"></path><path d="M870.4 739.2c-57.6 0-104 46.4-104 104s46.4 104 104 104 104-46.4 104-104-46.4-104-104-104z m33.6 152c-6.4 8-16 11.2-27.2 14.4v16H864v-16c-9.6-1.6-19.2-4.8-25.6-11.2-6.4-6.4-11.2-16-12.8-27.2l24-3.2c1.6 4.8 3.2 9.6 4.8 12.8l8 8V848c-11.2-3.2-20.8-8-25.6-14.4-4.8-6.4-8-14.4-8-24s3.2-17.6 9.6-24c6.4-6.4 14.4-11.2 24-11.2v-9.6h12.8v9.6c9.6 1.6 17.6 4.8 22.4 9.6 6.4 4.8 9.6 12.8 11.2 20.8l-22.4 3.2c-1.6-6.4-4.8-11.2-11.2-14.4v35.2c14.4 3.2 24 9.6 28.8 14.4 4.8 6.4 8 14.4 8 24 1.6 8-1.6 17.6-8 24z" fill="#1296db" p-id="6914"></path></svg>
					</div>
					<div class="limit_text">{{ $t('item.MinimumTransferIn') }}{{ projectData ? '$' + projectData.min : '$0' }}</div>
				</div>
				<div class="limit_item">
					<div class="limit_symbol">
						<svg t="1761441961128" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6907" width="30" height="30"><path d="M542.4 750.4v-32c22.4-3.2 38.4-11.2 51.2-25.6 12.8-14.4 17.6-30.4 17.6-51.2 0-17.6-4.8-33.6-14.4-44.8-9.6-11.2-28.8-20.8-54.4-28.8v-65.6c11.2 4.8 17.6 14.4 20.8 27.2l41.6-6.4c-3.2-17.6-9.6-30.4-20.8-40-9.6-9.6-24-16-43.2-17.6v-16h-24v16c-19.2 1.6-35.2 9.6-46.4 22.4-11.2 12.8-17.6 27.2-17.6 46.4 0 17.6 4.8 33.6 16 46.4 11.2 12.8 27.2 22.4 48 28.8v70.4c-6.4-3.2-11.2-8-16-14.4-4.8-6.4-8-14.4-9.6-22.4l-44.8 4.8c3.2 22.4 11.2 40 22.4 51.2 12.8 12.8 28.8 19.2 48 22.4V752h25.6z m0-134.4c9.6 3.2 17.6 6.4 22.4 12.8 4.8 4.8 6.4 12.8 6.4 19.2 0 8-3.2 16-8 22.4-4.8 6.4-12.8 9.6-20.8 11.2v-65.6z m-41.6-67.2c-3.2-4.8-4.8-11.2-4.8-16 0-6.4 1.6-12.8 6.4-17.6 4.8-4.8 9.6-9.6 16-11.2V560c-8-3.2-14.4-6.4-17.6-11.2z" fill="#1296db" p-id="6908"></path><path d="M172.8 708.8V489.6c44.8 0 80-35.2 80-80h206.4l-40-48H174.4c-27.2 0-49.6 22.4-49.6 49.6v374.4c0 27.2 22.4 49.6 49.6 49.6h508.8c0-16 3.2-33.6 8-48H252.8c0-43.2-35.2-78.4-80-78.4zM804.8 409.6c0 44.8 35.2 80 80 80V656c16 1.6 33.6 4.8 48 9.6v-256c0-27.2-22.4-49.6-49.6-49.6H638.4l-40 48h206.4z" fill="#1296db" p-id="6909"></path><path d="M340.8 558.4H288c-4.8 0-8 3.2-8 8s3.2 8 8 8h54.4c4.8 0 8-3.2 8-8s-4.8-8-9.6-8zM340.8 592H288c-4.8 0-8 3.2-8 8s3.2 8 8 8h54.4c4.8 0 8-3.2 8-8s-4.8-8-9.6-8zM340.8 624H288c-4.8 0-8 3.2-8 8s3.2 8 8 8h54.4c4.8 0 8-3.2 8-8-1.6-4.8-4.8-8-9.6-8zM771.2 558.4h-54.4c-4.8 0-8 3.2-8 8s3.2 8 8 8h54.4c4.8 0 8-3.2 8-8s-4.8-8-8-8zM771.2 592h-54.4c-4.8 0-8 3.2-8 8s3.2 8 8 8h54.4c4.8 0 8-3.2 8-8s-4.8-8-8-8zM771.2 640c4.8 0 8-3.2 8-8s-3.2-8-8-8h-54.4c-4.8 0-8 3.2-8 8s3.2 8 8 8h54.4zM515.2 427.2c6.4 8 19.2 8 27.2 0l70.4-86.4c9.6-11.2 1.6-28.8-12.8-28.8h-11.2V44.8c0-9.6-8-17.6-17.6-17.6h-84.8c-9.6 0-17.6 8-17.6 17.6v267.2h-11.2c-14.4 0-22.4 17.6-12.8 28.8l70.4 86.4zM25.6 307.2c0-70.4 57.6-128 128-128s128 57.6 128 128c0 8 0 16-1.6 22.4h27.2c1.6-8 1.6-14.4 1.6-22.4 0-84.8-68.8-153.6-153.6-153.6-86.4 0-155.2 68.8-155.2 153.6 0 62.4 38.4 116.8 92.8 140.8v-28.8c-40-22.4-67.2-64-67.2-112z" fill="#1296db" p-id="6910"></path><path d="M136 270.4c0 3.2 1.6 6.4 3.2 9.6 1.6 3.2 4.8 4.8 8 6.4V256c-3.2 0-6.4 3.2-8 4.8-1.6 3.2-3.2 6.4-3.2 9.6zM160 315.2v35.2c4.8-1.6 8-3.2 11.2-6.4 3.2-3.2 4.8-8 4.8-11.2v-3.2c0-3.2-1.6-4.8-3.2-8-3.2-3.2-6.4-4.8-12.8-6.4z" fill="#1296db" p-id="6911"></path><path d="M132.8 329.6c0 3.2 1.6 6.4 3.2 9.6 0 1.6 1.6 1.6 1.6 3.2l8 8v-36.8c-9.6-4.8-17.6-9.6-24-17.6-4.8-6.4-8-14.4-8-24s3.2-17.6 9.6-24c6.4-6.4 14.4-11.2 24-11.2v-9.6h12.8v9.6c9.6 1.6 17.6 4.8 22.4 9.6 6.4 4.8 9.6 12.8 11.2 20.8l-22.4 3.2c-1.6-6.4-4.8-11.2-11.2-14.4v35.2c14.4 3.2 24 9.6 28.8 14.4 4.8 6.4 8 14.4 8 24h57.6c1.6-8 3.2-14.4 3.2-22.4 0-57.6-46.4-104-104-104s-104 46.4-104 104c0 35.2 17.6 67.2 44.8 84.8 3.2-16 11.2-28.8 22.4-40-3.2-6.4-6.4-12.8-8-20.8l24-1.6zM870.4 689.6c-84.8 0-153.6 68.8-153.6 153.6s68.8 153.6 153.6 153.6S1024 928 1024 843.2s-68.8-153.6-153.6-153.6z m0 280c-70.4 0-128-57.6-128-128s57.6-128 128-128 128 57.6 128 128c0 72-57.6 128-128 128z" fill="#1296db" p-id="6912"></path><path d="M856 796.8c-1.6 3.2-3.2 6.4-3.2 9.6 0 3.2 1.6 6.4 3.2 9.6 1.6 3.2 4.8 4.8 8 6.4v-30.4c-3.2 0-6.4 3.2-8 4.8zM876.8 851.2v35.2c4.8-1.6 8-3.2 11.2-6.4 3.2-3.2 4.8-8 4.8-11.2 0-4.8-1.6-8-3.2-11.2-3.2-3.2-6.4-4.8-12.8-6.4z" fill="#1296db" p-id="6913"></path><path d="M870.4 739.2c-57.6 0-104 46.4-104 104s46.4 104 104 104 104-46.4 104-104-46.4-104-104-104z m33.6 152c-6.4 8-16 11.2-27.2 14.4v16H864v-16c-9.6-1.6-19.2-4.8-25.6-11.2-6.4-6.4-11.2-16-12.8-27.2l24-3.2c1.6 4.8 3.2 9.6 4.8 12.8l8 8V848c-11.2-3.2-20.8-8-25.6-14.4-4.8-6.4-8-14.4-8-24s3.2-17.6 9.6-24c6.4-6.4 14.4-11.2 24-11.2v-9.6h12.8v9.6c9.6 1.6 17.6 4.8 22.4 9.6 6.4 4.8 9.6 12.8 11.2 20.8l-22.4 3.2c-1.6-6.4-4.8-11.2-11.2-14.4v35.2c14.4 3.2 24 9.6 28.8 14.4 4.8 6.4 8 14.4 8 24 1.6 8-1.6 17.6-8 24z" fill="#1296db" p-id="6914"></path></svg>
					</div>
					<div class="limit_text">{{ $t('item.MaximumTransferIn') }}{{ projectData ? '$' + projectData.max : '$0' }}</div>
				</div>
			</div>
		</div>

		<!-- 白色内容区域 -->
		<div class="white_section">
			<!-- 平台介绍 -->
			<div class="platform_intro">
				<div v-if="projectData && projectData.content" v-html="projectData.content"></div>
				<div v-else>{{ $t('item.Loading') }}</div>
			</div>
			
			<!-- 操作按钮 -->
			<div class="action_buttons">
				<div 
					class="btn_transfer_out" 
					:class="{ 'btn_disabled': !canTransferOut }"
					@click="canTransferOut ? transferOut() : showTransferOutTip()"
				>
					{{ canTransferOut ? $t('item.TransferOut') : $t('item.TransferOutDisabled') }}
				</div>
				<div class="btn_quick_transfer" @click="quickTransfer">
					{{ $t('item.QuickTransferIn') }}
				</div>
			</div>
		</div>

		<!-- 底部导航栏 -->
		<FooterTab :activeType="'item'" />
		
		<!-- 转入弹窗 -->
		<div v-if="showTransferDialog" class="transfer_dialog">
			<div class="dialog_mask" @click="cancelTransfer"></div>
			<div class="dialog_content">
				<div class="dialog_header">
					<h3>{{ $t('item.QuickTransfer') }}</h3>
					<span class="close_btn" @click="cancelTransfer">×</span>
				</div>
				<div class="dialog_body">
					<!-- 账户余额 -->
					<div class="input_group">
						<label>{{ $t('item.AccountBalance') }}：</label>
						<div class="balance_display">
							<span v-if="loadingBalance" class="loading_text">加载中...</span>
							<span v-else>${{ userBalance }}</span>
						</div>
					</div>
					<!-- 转入金额 -->
					<div class="input_group">
						<label>{{ $t('item.TransferAmount') }}：</label>
						<input 
							type="number" 
							v-model="transferAmount" 
							:placeholder="$t('item.PleaseEnterTransferAmount')"
							:min="projectData ? projectData.min : 0"
							:max="projectData ? projectData.max : 9999999"
						/>
					</div>
					<!-- 交易密码 -->
					<div class="input_group">
						<label>{{ $t('item.TransactionPassword') }}：</label>
						<input 
							type="password" 
							v-model="transactionPassword" 
							:placeholder="$t('item.PleaseEnterTransactionPassword')"
						/>
					</div>
				</div>
				<div class="dialog_footer">
					<button class="btn_cancel" @click="cancelTransfer">{{ $t('common.Cancel') }}</button>
					<button class="btn_confirm" @click="confirmTransfer">{{ $t('common.Confirm') }}</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Fetch from '../../utils/fetch';
import FooterTab from '../../components/FooterTab.vue'

export default {
	name: "ProjectDetail",
	data() {
		return {
			show_icon_type: 'item',
			projectData: null, // 存储项目详情数据
			transferAmount: '', // 转入金额
			transactionPassword: '', // 交易密码
			showTransferDialog: false, // 是否显示转入弹窗
			countdownTimer: null, // 倒计时定时器
			currentCountdown: 0, // 当前倒计时秒数
			nextIncomeTime: '', // 下次收益时间
			userBalance: '0.00', // 用户账户余额
			loadingBalance: false // 余额加载状态
		};
	},
	components: { FooterTab },
	created() {
		this.$parent.footer("item", false);
		this.show_icon_type = 'item';
		this.getProjectDetail();
	},
	beforeDestroy() {
		// 组件销毁前清除定时器
		this.clearCountdownTimer();
	},
	methods: {
		// 获取项目详情
		async getProjectDetail() {
			try {
				const projectId = this.$route.query.id;
				if (!projectId) {
					console.log('没有项目ID参数');
					return;
				}
				
				const result = await Fetch('/index/item_detail', { id: projectId });
				
				if (result.code === 1 && result.data) {
					this.projectData = result.data;
					console.log(result.data);
					
					// 初始化倒计时
					this.initCountdown();
				} else {
					console.error('获取项目详情失败:', result);
				}
			} catch (error) {
				console.error('请求项目详情出错:', error);
			}
		},
		
		async transferOut(event) {
			// 检查用户是否登录
			const token = localStorage.getItem('token');
			if (!token) {
				this.$toast({
					message: this.$t('common.PleaseLoginFirst'),
					type: 'warning',
					duration: 3000
				});
				this.$router.push('/login');
				return;
			}
			
			try {
				console.log('开始项目转出操作...');
				
				// 动态获取项目ID
				const projectId = this.$route.query.id;
				if (!projectId) {
					console.log('没有项目ID参数');
					this.$toast({
						message: this.$t('item.ProjectIdMissing'),
						type: 'warning',
						duration: 3000
					});
					return;
				}
				
				// 准备请求参数
				const requestParams = {
					id: projectId,
					language: localStorage.getItem('lang') || 'zh_hk'
				};
				
				// 如果按住Shift键，添加调试参数
				if (event && event.shiftKey) {
					requestParams.debug = true;
					console.log('🔍 调试模式已启用');
				}
				
				console.log('转出请求参数:', requestParams);
				
				// 调用项目转出接口
				const result = await Fetch('/index/item_interest_to_principal', requestParams);
				
				console.log('项目转出API响应:', result);
				
				// 如果是调试模式，显示调试信息
				if (requestParams.debug && result && result.code === 1) {
					console.log('🔍 调试信息:', result.data);
					this.$toast({
						message: '调试信息已输出到控制台，请查看浏览器开发者工具',
						type: 'success',
						duration: 3000
					});
					return;
				}
				
				if (result && result.code === 1) {
					console.log('项目转出成功:', result);
					// 显示后端返回的成功消息，如果没有则使用默认翻译
					const successMessage = result.info || this.$t('item.TransferOutSuccess');
					
					// 使用Vant Toast显示成功消息
					this.$toast({
						message: successMessage,
						type: 'success',
						duration: 3000
					});
					
					// 延迟刷新项目详情数据，确保Toast提示能正常显示
					setTimeout(async () => {
						await this.getProjectDetail();
					}, 1000);
				} else if (result && result.code === 0) {
					console.log('项目转出业务提示:', result);
					// 显示业务提示信息
					let message = '';
					if (typeof result.info === 'string') {
						message = result.info;
					} else if (typeof result.info === 'object') {
						const currentLang = localStorage.getItem('lang') || 'zh_hk';
						message = result.info[currentLang] || result.info.zh_cn || this.$t('item.TransferOutFailed');
					}
					
					this.$toast({
						message: message,
						type: 'warning',
						duration: 3000
					});
				} else {
					console.error('项目转出失败:', result);
					// 优先显示后端返回的错误信息
					let errorMsg = '';
					if (result && result.info) {
						if (typeof result.info === 'string') {
							errorMsg = result.info;
						} else if (typeof result.info === 'object') {
							const currentLang = localStorage.getItem('lang') || 'zh_hk';
							errorMsg = result.info[currentLang] || result.info.zh_cn || this.$t('item.TransferOutFailed');
						}
					} else {
						errorMsg = this.$t('item.TransferOutFailed');
					}
					
					this.$toast({
						message: errorMsg,
						type: 'fail',
						duration: 3000
					});
				}
			} catch (error) {
				console.error('项目转出请求出错:', error);
				// 网络错误已经在fetch.js中处理了，这里不需要重复提示
				// 只有在非网络错误的情况下才显示提示
				if (error && error.msg) {
					// 检查error.msg是字符串还是对象
					let errorMessage = '';
					if (typeof error.msg === 'string') {
						errorMessage = error.msg;
					} else if (typeof error.msg === 'object') {
											// 如果是对象，尝试获取当前语言的错误信息
					const currentLang = localStorage.getItem('lang') || 'zh_cn';
					errorMessage = error.msg[currentLang] || error.msg.zh_cn || this.$t('item.OperationFailed');
					}
					
					// 如果不是网络错误，才显示提示
					if (errorMessage && !errorMessage.includes('网络错误')) {
						this.$toast({
							message: errorMessage,
							type: 'fail',
							duration: 3000
						});
					}
				}
			}
		},
		async quickTransfer() {
			// 检查用户是否登录
			const token = localStorage.getItem('token');
			if (!token) {
				this.$toast({
					message: this.$t('common.PleaseLoginFirst'),
					type: 'warning',
					duration: 3000
				});
				this.$router.push('/login');
				return;
			}
			
			// 设置默认转入金额为项目最小转入金额
			if (this.projectData && this.projectData.min) {
				// this.transferAmount = this.projectData.min;
			} else {
				this.transferAmount = "1000";
			}
			
			// 显示转入弹窗
			this.showTransferDialog = true;
			
			// 获取用户余额
			await this.getUserBalance();
		},
		
		async confirmTransfer() {
			// 确认转入操作
			try {
				// 验证转入金额
				if (!this.transferAmount || parseFloat(this.transferAmount) <= 0) {
					this.$toast({
						message: this.$t('item.PleaseEnterValidTransferAmount'),
						type: 'warning',
						duration: 3000
					});
					return;
				}
				
				// 验证交易密码
				if (!this.transactionPassword) {
					this.$toast({
						message: this.$t('item.PleaseEnterTransactionPassword'),
						type: 'warning',
						duration: 3000
					});
					return;
				}
				
				// 验证金额范围
				if (this.projectData) {
					const amount = parseFloat(this.transferAmount);
					if (amount < this.projectData.min) {
						this.$toast({
							message: this.$t('item.TransferAmountCannotBeLessThan', { amount: this.projectData.min }),
							type: 'warning',
							duration: 3000
						});
						return;
					}
					if (amount > this.projectData.max) {
						this.$toast({
							message: this.$t('item.TransferAmountCannotBeGreaterThan', { amount: this.projectData.max }),
							type: 'warning',
							duration: 3000
						});
						return;
					}
				}
				
				// 动态获取项目ID
				const projectId = this.$route.query.id;
				if (!projectId) {
					console.log('没有项目ID参数');
					this.$toast({
						message: this.$t('item.ProjectIdMissing'),
						type: 'warning',
						duration: 3000
					});
					return;
				}
				
				// 动态获取用户token
				const token = localStorage.getItem('token');
				if (!token) {
					this.$toast({
						message: this.$t('common.PleaseLoginFirst'),
						type: 'warning',
						duration: 3000
					});
					this.$router.push('/login');
					return;
				}
				
				// 调用快速转入接口
				const result = await Fetch('/index/item_apply', {
					id: projectId,
					money: this.transferAmount,
					paypwd: this.transactionPassword,
					token: token
				});
				
				if (result && result.code === 1) {
					console.log('快速转入成功:', result);
					// 可以添加成功提示
					this.$toast({
						message: this.$t('item.TransferInSuccess'),
						type: 'success',
						duration: 3000
					});
					this.showTransferDialog = false;
					this.transactionPassword = '';
					// 延迟刷新项目详情数据，确保Toast提示能正常显示
					setTimeout(async () => {
						await this.getProjectDetail();
					}, 1000);
				} else if (result && result.code === 0) {
					// code: 0 表示业务提示信息，显示给用户
					console.log('业务提示:', result);
					let message = '';
					if (typeof result.info === 'string') {
						message = result.info;
					} else if (typeof result.info === 'object') {
						const currentLang = localStorage.getItem('lang') || 'zh_hk';
						message = result.info[currentLang] || result.info.zh_cn || this.$t('item.OperationTip');
					}
					this.$toast({
						message: message,
						type: 'warning',
						duration: 3000
					});
					this.showTransferDialog = false;
				} else {
					console.error('快速转入失败:', result);
					// 可以添加失败提示
					const errorMsg = result && result.info ? result.info : this.$t('item.TransferInFailed');
					this.$toast({
						message: errorMsg,
						type: 'fail',
						duration: 3000
					});
				}
			} catch (error) {
				console.error('快速转入请求出错:', error);
				// 网络错误已经在fetch.js中处理了，这里不需要重复提示
				// 只有在非网络错误的情况下才显示提示
				if (error && error.msg) {
					// 检查error.msg是字符串还是对象
					let errorMessage = '';
					if (typeof error.msg === 'string') {
						errorMessage = error.msg;
					} else if (typeof error.msg === 'object') {
											// 如果是对象，尝试获取当前语言的错误信息
					const currentLang = localStorage.getItem('lang') || 'zh_cn';
					errorMessage = error.msg[currentLang] || error.msg.zh_cn || this.$t('item.OperationFailed');
					}
					
					// 如果不是网络错误，才显示提示
					if (errorMessage && !errorMessage.includes('网络错误')) {
						this.$toast({
							message: errorMessage,
							type: 'fail',
							duration: 3000
						});
					}
				}
			}
		},
		
		cancelTransfer() {
			// 取消转入操作
			this.showTransferDialog = false;
			this.transferAmount = '';
			this.transactionPassword = '';
		},
		getUnitText(unit) {
			switch (unit) {
				case 'hours':
					return this.$t('utils.hours');
				case 'hour':
					return this.$t('utils.hours');
				case 'days':
					return this.$t('utils.days');
				case 'day':
					return this.$t('utils.days');
				case 'months':
					return this.$t('utils.months');
				case 'month':
					return this.$t('utils.months');
				case 'years':
					return this.$t('utils.years');
				case 'year':
					return this.$t('utils.years');
				default:
					return unit;
			}
		},
		// 初始化倒计时
		initCountdown() {
			if (this.projectData && this.projectData.countdown > 0) {
				this.currentCountdown = this.projectData.countdown;
				this.nextIncomeTime = this.projectData.next_income_time || '';
				this.startCountdown();
			}
		},
		
		// 开始倒计时
		startCountdown() {
			// 清除之前的定时器
			this.clearCountdownTimer();
			
			// 创建新的定时器，每秒更新一次
			this.countdownTimer = setInterval(() => {
				if (this.currentCountdown > 0) {
					this.currentCountdown--;
					
					// 如果倒计时结束，刷新项目详情
					if (this.currentCountdown <= 0) {
						this.clearCountdownTimer();
						// 延迟1秒后刷新数据，确保后端已处理
						setTimeout(() => {
							this.getProjectDetail();
						}, 1000);
					}
				} else {
					this.clearCountdownTimer();
				}
			}, 1000);
		},
		
		// 清除倒计时定时器
		clearCountdownTimer() {
			if (this.countdownTimer) {
				clearInterval(this.countdownTimer);
				this.countdownTimer = null;
			}
		},
		
		// 格式化倒计时显示（精确到秒）
		formatCountdown(seconds) {
			if (seconds === null || seconds === undefined || seconds === 0) {
				return '0' + this.$t('utils.seconds');
			}

			const days = Math.floor(seconds / (3600 * 24));
			const hours = Math.floor((seconds % (3600 * 24)) / 3600);
			const minutes = Math.floor((seconds % 3600) / 60);
			const secs = seconds % 60;

			let result = '';
			if (days > 0) {
				result += `${days}${this.$t('utils.days')}`;
			}
			if (hours > 0) {
				result += `${hours}:`;
			}
			if (minutes > 0) {
				result += `${minutes}:`;
			}
			if (secs > 0 || (days === 0 && hours === 0 && minutes === 0)) {
				result += `${secs}`;
			}
			return result || '0' ;
		},
		
		// 获取当前倒计时显示文本
		getCurrentCountdownText() {
			if (this.currentCountdown <= 0) {
				return this.$t('item.NoTransfer');
			}
			
			// ≥ 24 小時：固定顯示天/時/分/秒
			if (this.currentCountdown >= 86400) {
				return this.formatCountdownFull(this.currentCountdown);
			}
			// // < 1 小時：緊湊格式
			// if (this.currentCountdown >= 3600) {
			// 	return this.formatCompactCountdown(this.currentCountdown);
			// }
			// // 如果时间很短（小于1小时），使用更紧凑的格式
			// if (this.currentCountdown < 3600) {
			// 	return this.formatCompactCountdown(this.currentCountdown);
			// }
			
			return this.formatCountdown(this.currentCountdown);
		},
		// 固定顯示：X天X小時X分鐘X秒（全都顯示，哪怕為 0）
		formatCountdownFull(seconds) {
			if (seconds == null || seconds <= 0) {
				return '0' + this.$t('utils.seconds');
			}
			const days = Math.floor(seconds / 86400);
			const hours = Math.floor((seconds % 86400) / 3600);
			const minutes = Math.floor((seconds % 3600) / 60);
			const secs = seconds % 60;

			return (
				`${days}${this.$t('utils.day')} ` +
				`${hours}:` +
				`${minutes}:` +
				`${secs}`
			);
		},
		// 紧凑格式倒计时（用于短时间显示）
		formatCompactCountdown(seconds) {
			if (seconds === null || seconds === undefined || seconds === 0) {
				return '0' + this.$t('utils.seconds');
			}

			const minutes = Math.floor(seconds / 60);
			const secs = seconds % 60;

			if (minutes > 0) {
				return `${minutes}:${secs.toString().padStart(2, '0')}`;
			} else {
				return `${secs}${this.$t('utils.seconds')}`;
			}
		},// hours: 傳入的剩餘時間（小時數）
		formatTimeLeft(hours) {
			if (hours < 24) {
				return `${hours.toFixed(1)} ${this.$t('utils.hours')}`; // 保留 1 位小數
			} else {
				const days = Math.floor(hours / 24); // 整天數
				const remainingHours = Math.floor(hours % 24); // 剩餘小時
				return `${days} ${this.$t('utils.day')} ${remainingHours} ${this.$t('utils.hours')}`;
			}
		},
		
		// 获取用户余额
		async getUserBalance() {
			try {
				this.loadingBalance = true;
				console.log('💰 开始获取用户余额...');
				
				// 调用用户信息API获取余额
				const result = await Fetch('/user/info');
				
				console.log('💰 用户信息API响应:', result);
				
				if (result && result.code === 1 && result.data) {
					console.log('✅ 用户余额获取成功');
					this.userBalance = result.data.money || '0.00';
					console.log('💰 当前余额:', this.userBalance);
				} else {
					console.error('❌ 用户余额获取失败:', result);
					this.userBalance = '0.00';
					// 显示错误提示
					if (result && result.info) {
						this.$toast({
							message: result.info,
							type: 'warning',
							duration: 3000
						});
					}
				}
			} catch (error) {
				console.error('💥 获取用户余额出错:', error);
				this.userBalance = '0.00';
				// 网络错误已经在fetch.js中处理了，这里不需要重复提示
			} finally {
				this.loadingBalance = false;
				console.log('🏁 余额获取完成，loading状态:', this.loadingBalance);
			}
		},
		
		// 显示转出限制提示
		showTransferOutTip() {
			if (!this.projectData) return;
			
			const hasPrincipal = parseFloat(this.projectData.total_principal || 0) > 0;
			if (!hasPrincipal) {
				this.$toast({
					message: this.$t('item.NoInvestmentToTransferOut'),
					type: 'warning',
					duration: 3000
				});
				return;
			}
			
			if (this.currentCountdown > 0) {
				const timeLeft = this.formatCountdown(this.currentCountdown);
				this.$toast({
					message: this.$t('item.TransferOutAfterProjectEnds', { time: timeLeft }),
					type: 'warning',
					duration: 4000
				});
			}
		}
	},
	computed: {
		// 倒计时样式类
		countdownClass() {
			if (this.currentCountdown <= 300) { // 5分钟内
				return 'countdown-urgent';
			} else if (this.currentCountdown <= 1800) { // 30分钟内
				return 'countdown-warning';
			}
			return 'countdown-normal';
		},
		
		// 是否可以转出
		canTransferOut() {
			if (!this.projectData) return false;
			
			// 检查是否有本金投入（total_principal > 0）
			const hasPrincipal = parseFloat(this.projectData.total_principal || 0) > 0;
			if (!hasPrincipal) {
				return false; // 没有投资就不能转出
			}
			
			// 检查倒计时是否结束（项目是否到期）
			const isProjectFinished = this.currentCountdown <= 0;
			
			return isProjectFinished;
		}
	}
};
</script>

<style lang="less" scoped>
.basic_wrap {
	// min-height: 100vh;
	height: calc(100vh - 60px);
	background: #f7f7f7; // 修改为与白色内容区域一致的背景色
	display: flex;
	flex-direction: column;
	overflow: hidden; // 防止内容溢出
}

/* 顶部标题 */
.project_header {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #4182ce;
	color: #ffffff;
	z-index: 1000; // 确保在最顶层

	.back_left {
		position: absolute;
		left: 15px;
		top: 0;
		bottom: 0;
		cursor: pointer;
		background: none;
		display: flex;
		align-items: center;
		justify-content: center;
		
		img {
			width: 16px;
			height: 16px;
		}
	}

	.big_tit {
		font-size: 16px;
		font-weight: 500;
		color: #ffffff;
		line-height: 1;
		display: flex;
		align-items: center;
		justify-content: center;
	}
}

/* 蓝色主要内容区域 */
.blue_section {
	// position: fixed;
	// top: 40px; // 紧贴顶部标题下方
	// left: 0;
	// right: 0;
	// background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%);
	margin-top: 40px;
	background-color: #4182ce;
	padding: 15px; // 增加内边距
	color: #ffffff;
	border-bottom-left-radius: 15px;
	border-bottom-right-radius: 15px;
	box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
	z-index: 999; // 确保在标题下方但在其他内容之上
	
	.product_name {
		text-align: center;
		font-size: 16px;
		font-weight: 500;
		margin-bottom: 15px; // 增加底部间距
	}
	
	.rate_bubble {
		text-align: center;
		margin-bottom: 25px; // 调整间距
		
		.rate_text {
			background: rgba(255, 255, 255, 0.2);
			padding: 8px 16px;
			border-radius: 20px;
			display: inline-block;
			font-size: 14px;
		}
		
		.rate_arrow {
			width: 0;
			height: 0;
			border-left: 8px solid transparent;
			border-right: 8px solid transparent;
			border-bottom: 8px solid rgba(255, 255, 255, 0.2);
			margin: 0 auto;
		}
	}
	
	.financial_grid {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr 1fr;
		gap: 15px;
		margin-bottom: 25px; // 调整间距
		
		.grid_item {
			text-align: center;
			
			.grid_label {
				font-size: 14px;
				opacity: 0.8;
				margin-bottom: 5px;
			}
			
			.grid_value {
				font-size: 14px;
				margin-top: 10px;
				font-weight: 600;
				white-space: nowrap; // 防止换行
				
				&.countdown-normal {
					color: #ffffff;
				}
				
/*				&.countdown-warning {
					color: #ffd700;
					animation: pulse 2s infinite;
				}
				
				&.countdown-urgent {
					color: #ff4757;
					animation: blink 1s infinite;
				}
					*/
			}
		}
	}
	
	.transfer_limits {
		display: flex;
		gap: 20px;
		justify-content: center;
		background-color: #fff;
		border-radius: 10px;
		padding: 15px 0; // 增加内边距
		color: #3e80cc;
		box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
		
		.limit_item {
			text-align: center;
			
			.limit_symbol {
				font-size: 24px;
				font-weight: bold;
				margin-bottom: 5px;
				img{
					width: 30px;
					height: 30px;
				}
			}
			
			.limit_text {
				font-size: 12px;
				opacity: 0.9;
			}
		}
	}
}

/* 白色内容区域 */
.white_section {
	flex: 1;
	padding: 10px;
	// padding-top: 330px; // 为固定的顶部和蓝色区域留出足够空间
	background: #f7f7f7;
	overflow-y: auto; // 允许内容滚动
	box-sizing: border-box;
	padding-bottom: 80px; // 为底部tab栏留出空间
	box-sizing: border-box;
	
	.platform_intro {
		height: 150px;
		margin-bottom: 40px;
		font-size: 14px;
    	line-height: 24px;
		background-color: #fff;
		padding: 20px; // 增加内边距
		border-radius: 8px;
		overflow-y: auto;
		box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
		
		p {
			font-size: 18px; // 增大字体大小
			color: #666;
			line-height: 2.2; // 增加行高
			text-align: justify;
			margin-bottom: 25px; // 增加段落间距
			
			&:last-child {
				margin-bottom: 0;
			}
		}
	}
	
	.action_buttons {
		display: flex;
		gap: 15px;
		
		.btn_transfer_out {
			flex: 1;
			height: 48px;
			background: #ffffff;
			color: #1890ff;
			border: 2px solid #1890ff;
			border-radius: 50px;
			font-size: 16px;
			font-weight: 500;
			cursor: pointer;
			display: flex;
			align-items: center;
			justify-content: center;
			transition: all 0.3s;
			
			&:hover {
				background: #f0f8ff;
			}
			
			&.btn_disabled {
				background: #f5f5f5;
				color: #999;
				border-color: #ddd;
				cursor: not-allowed;
				
				&:hover {
					background: #f5f5f5;
				}
			}
		}
		
		.btn_quick_transfer {
			flex: 1;
			height: 48px;
			background: #337ccf;
			color: #ffffff;
			border: none;
			border-radius: 50px;
			font-size: 16px;
			font-weight: 500;
			cursor: pointer;
			display: flex;
			align-items: center;
			justify-content: center;
			transition: background-color 0.3s;
			
			&:hover {
				background: #40a9ff;
			}
		}
	}
}

/* 底部导航栏样式已移至FooterTab组件 */

/* 转入弹窗样式 */
.transfer_dialog {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 2000;
	display: flex;
	align-items: center;
	justify-content: center;
}

.dialog_mask {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
}

.dialog_content {
	position: relative;
	width: 300px;
	background: #fff;
	border-radius: 8px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.dialog_header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 16px 20px;
	border-bottom: 1px solid #e5e5e5;
	
	h3 {
		margin: 0;
		font-size: 16px;
		color: #333;
	}
	
	.close_btn {
		font-size: 20px;
		color: #999;
		cursor: pointer;
		width: 20px;
		height: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		
		&:hover {
			color: #333;
		}
	}
}

.dialog_body {
	padding: 20px;
	
	.input_group {
		margin-bottom: 16px;
		
		label {
			display: block;
			margin-bottom: 8px;
			font-size: 14px;
			color: #333;
		}
		
		input {
			width: 100%;
			height: 40px;
			padding: 0 12px;
			border: 1px solid #ddd;
			border-radius: 4px;
			font-size: 14px;
			box-sizing: border-box;
			
			&:focus {
				outline: none;
				border-color: #007aff;
			}
		}
		
		.balance_display {
			width: 100%;
			height: 40px;
			padding: 0 12px;
			border: 1px solid #ddd;
			border-radius: 4px;
			font-size: 14px;
			box-sizing: border-box;
			background-color: #f5f5f5;
			color: #333;
			display: flex;
			align-items: center;
			cursor: not-allowed;
			
			.loading_text {
				color: #999;
				font-style: italic;
			}
		}
	}
	
	.amount_info {
		background: #f5f5f5;
		padding: 12px;
		border-radius: 4px;
		
		p {
			margin: 0 0 4px 0;
			font-size: 12px;
			color: #666;
			
			&:last-child {
				margin-bottom: 0;
			}
		}
	}
}

.dialog_footer {
	display: flex;
	padding: 16px 20px;
	border-top: 1px solid #e5e5e5;
	gap: 12px;
	
	button {
		flex: 1;
		height: 40px;
		border: none;
		border-radius: 4px;
		font-size: 14px;
		cursor: pointer;
		transition: all 0.3s;
	}
	
	.btn_cancel {
		background: #f5f5f5;
		color: #666;
		
		&:hover {
			background: #e5e5e5;
		}
	}
	
	.btn_confirm {
		background: #ff4757;
		color: #fff;
		
		&:hover {
			background: #e63946;
		}
	}
}

/* 倒计时动画 */
@keyframes pulse {
	0% {
		opacity: 1;
	}
	50% {
		opacity: 0.7;
	}
	100% {
		opacity: 1;
	}
}

@keyframes blink {
	0% {
		opacity: 1;
	}
	50% {
		opacity: 0.3;
	}
	100% {
		opacity: 1;
	}
}
</style> 